// extracted by mini-css-extract-plugin
export var leftAlign = "_redotech-redo-web-lib-tooltip-tooltip-left-align";
export var popper = "_redotech-redo-web-lib-tooltip-tooltip-popper";
export var subtitle = "_redotech-redo-web-lib-tooltip-tooltip-subtitle";